/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 02/03/2022 15:07
 */

import { Factory } from '@infodata-group/inf-commons';
import { StandardMenuItem } from '../model/standard-menu-item';
import { GenericCrudAuthorization } from '../model/menu/generic-crud-authorization';
import { Layout } from '../model/menu/layout';

export class StandardMenuItemFactory implements Factory<StandardMenuItem> {
  public api: string;

  constructor(api: string) {
    this.api = api;
  }

  build(o: any): StandardMenuItem {
    const item = new StandardMenuItem(o.id, o.label, o.icon, o.route);
    item.disabled = o.disabled ?? false;

    if (o.CRUD) {
      item.CRUD = new GenericCrudAuthorization(
        o.CRUD.create,
        o.CRUD.read,
        o.CRUD.update,
        o.CRUD.delete,
      );
    }

    if (o.layout) {
      item.layout = new Layout(o.layout.endPoint);
      item.layout.profil = o.layout.profil;
      item.layout.container = o.layout.container;
      item.layout.pagination = o.layout.pagination;
      item.layout.urlGdx = o.layout.urlGdx;
      item.layout.directSearch = o.layout.directSearch;
    }

    if (o.children) {
      for (const child of o.children) {
        const c = this.build(child);
        c.parentId = item.id;
        item.submenus.push(c);
      }
    }

    return item;
  }

  getApi(): string {
    return this.api;
  }
}
